import React, { useState, useEffect, useRef } from 'react';
import englishFlagImage from '../assets/united-states.png'
import japaneseFlagImage from '../assets/square.png'
import indonesianFlagImage from '../assets/indonasian.png'
import bangladeshFlagImage from '../assets/bangladeshi.png'
import filipinoFlagImage from '../assets/filipino.png'
import vietnameseFlagImage from '../assets/vietnamese.png'
import sriLankanFlagImage from '../assets/sriLankan.png'
import nepaliFlagImage from '../assets/nepali.png'
import defaultFlagImage from '../assets/square.png';
import JapanFlag from '../assets/japaneseFlagNew.svg';
import USFlag from '../assets/US.svg';
import './dropDown.css';
import { Tooltip } from '@chakra-ui/react';

const LanguageDropDown = ({ setLanguage, translate }) => {
    const flagMap = {
        English: USFlag,
        Japanese: JapanFlag,
        // Indonesian: indonesianFlagImage,
        // Nepali: nepaliFlagImage,
        // Sinhala: sriLankanFlagImage,
        // Vietnamese: vietnameseFlagImage,
        // Filipino: filipinoFlagImage,
        // Bengali: bangladeshFlagImage
    };
    const languages = [
        { name: 'Japanese', flag: JapanFlag },
        { name: 'English', flag: USFlag },
        // { name: 'Indonesian', flag: indonesianFlagImage },
        // { name: 'Nepali', flag: nepaliFlagImage },
        // { name: 'Sinhala', flag: sriLankanFlagImage },
        // { name: 'Vietnamese', flag: vietnameseFlagImage },
        // { name: 'Filipino', flag: filipinoFlagImage },
        // { name: 'Bengali', flag: bangladeshFlagImage }
    ];
    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese'); // Default language
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const selectLanguage = (language) => {
        setLangOpt(language);
        setLanguage(language)
        setIsOpen(false); // Close dropdown after selecting
    };

    // Close dropdown on click outside (blur effect)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false); // Close dropdown if click is outside
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Tooltip className="tooltip">
            {/* label={translate("Select Language")} */}
            <div className="custom-dropdown-language" ref={dropdownRef}>
                {/* Selected option displayed here */}
                <div className="dropdown-header" onClick={toggleDropdown}>
                    <div className="lang-flag-dropdown">
                        <img src={flagMap[langOpt] || defaultFlagImage} alt={`${langOpt} Flag`}/>
                    </div>
                    <span>{langOpt}</span>
                    <svg
                        className={`arrow ${isOpen ? 'rotated' : ''}`}
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                    >
                        <path
                            d="M5 7.5L10 12.5L15 7.5"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                {/* Dropdown options */}
                <div className={`dropdown-options ${isOpen ? 'open' : 'close'}`}>
                    {languages.map(lang => (
                        <div key={lang.name} className="dropdown-option" onClick={() => selectLanguage(lang.name)}>
                            <img className="lang-flag-option" src={lang.flag} alt={`${lang.name} Flag`}/>
                            <span>{lang.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </Tooltip>
    );
};

export default LanguageDropDown;